import { Link } from "react-router-dom";
function Gozos() {
  return (
    <div className="bg-gozos-pattern bg-no-repeat bg-contain bg-right-bottom px-6 py-2">
      <div className="flex justify-left">
        <img
          className="w-12 h-12 mr-2 rounded-full"
          src="/img/iconos/Gozos_Icon.svg"
          alt="Ángel"
          title="Ángel"
        />
        <h1 className="text-yellow-main text-5xl">Gozos</h1>
      </div>
      <div className="flex md:justify-left lg:justify-left">
        <h2 className="text-white font-semibold md:text-3xl text-xl pb-4">
          Dulce Jesús mío, mi niño adorado,
        </h2>
      </div>
      <div className="flex md:justify-left lg:justify-left">
        <small className="text-yellow-main font-semibold pb-4">
          Coro: ¡Ven a nuestras almas, ven no tardes tanto!
        </small>
      </div>
      <div className="grid md:grid-cols-2 pb-20">
        <div className="mx-auto max-w-2xl py-2 lg:max-w-none lg:py-4 text-white">
          <div className="p-4 max-w-xl mx-auto">
            <div className="flex">
              <div className="mr-4 flex flex-col items-center">
                <div className="bg-blue-main">
                  <div className="bg-yellow-main flex h-10 w-10 items-center justify-center rounded-full">
                    <p className="text-blue-main">1</p>
                  </div>
                </div>
                <div className="h-full w-px bg-gray-300 dark:bg-slate-500"></div>
              </div>
              <div className="pt-1 pb-8">
                <p>
                  ¡Oh, Sapiencia suma del Dios soberano, que a infantil alcance
                  te rebajas sacro! ¡Oh, Divino Niño, ven para enseñarnos la
                  prudencia que hace verdaderos sabios!
                </p>
                <small className="text-yellow-main font-semibold pb-4">
                  Coro: ¡Ven a nuestras almas, ven no tardes tanto!
                </small>
              </div>
            </div>
            <div className="flex">
              <div className="mr-4 flex flex-col items-center">
                <div className="bg-blue-main">
                  <div className="bg-yellow-main flex h-10 w-10 items-center justify-center rounded-full">
                    <p className="text-blue-main">2</p>
                  </div>
                </div>
                <div className="h-full w-px bg-gray-300 dark:bg-slate-500"></div>
              </div>
              <div className="pt-1 pb-8">
                <p>
                  ¡Oh, Adonai potente que Moisés hablando, de Israel al pueblo
                  diste los mandatos! ¡Ah, ven prontamente para rescatarnos, y
                  que un niño débil muestre fuerte el brazo!
                </p>
                <small className="text-yellow-main font-semibold pb-4">
                  Coro: ¡Ven a nuestras almas, ven no tardes tanto!
                </small>
              </div>
            </div>
            <div className="flex">
              <div className="mr-4 flex flex-col items-center">
                <div className="bg-blue-main">
                  <div className="bg-yellow-main flex h-10 w-10 items-center justify-center rounded-full">
                    <p className="text-blue-main">3</p>
                  </div>
                </div>
                <div className="h-full w-px bg-gray-300 dark:bg-slate-500"></div>
              </div>
              <div className="pt-1 pb-8">
                <p>
                  ¡Oh, raíz sagrada de José que en lo alto presenta al orbe tu
                  fragante nardo! Dulcísimo Niño que has sido llamado Lirio de
                  los valles, Bella flor del campo.
                </p>
                <small className="text-yellow-main font-semibold pb-4">
                  Coro: ¡Ven a nuestras almas, ven no tardes tanto!
                </small>
              </div>
            </div>
            <div className="flex">
              <div className="mr-4 flex flex-col items-center">
                <div className="bg-blue-main">
                  <div className="bg-yellow-main flex h-10 w-10 items-center justify-center rounded-full">
                    <p className="text-blue-main">4</p>
                  </div>
                </div>
                <div className="h-full w-px bg-gray-300 dark:bg-slate-500"></div>
              </div>
              <div className="pt-1 pb-8">
                <p>
                  ¡Llave de David que abre al desterrado las cerradas puertas de
                  regio palacio! ¡Sácanos. Oh Niño con tu blanca mano, de la
                  cárcel triste que labró el pecado!
                </p>
                <small className="text-yellow-main font-semibold pb-4">
                  Coro: ¡Ven a nuestras almas, ven no tardes tanto!
                </small>
              </div>
            </div>
            <div className="flex">
              <div className="mr-4 flex flex-col items-center">
                <div className="bg-blue-main">
                  <div className="bg-yellow-main flex h-10 w-10 items-center justify-center rounded-full">
                    <p className="text-blue-main">5</p>
                  </div>
                </div>
                <div className="h-full w-px bg-gray-300 dark:bg-slate-500"></div>
              </div>
              <div className="pt-1 pb-8">
                <p>
                  ¡Oh, lumbre de Oriente, sol de eternos rayos, que entre las
                  tinieblas tu esplendor veamos! Niño tan precioso, dicha del
                  cristiano, luzca la sonrisa de tus dulces labios.
                </p>
                <small className="text-yellow-main font-semibold pb-4">
                  Coro: ¡Ven a nuestras almas, ven no tardes tanto!
                </small>
              </div>
            </div>
            <div className="flex">
              <div className="mr-4 flex flex-col items-center">
                <div className="bg-blue-main">
                  <div className="bg-yellow-main flex h-10 w-10 items-center justify-center rounded-full">
                    <p className="text-blue-main">6</p>
                  </div>
                </div>
                <div className="h-full w-px bg-gray-300 dark:bg-slate-500"></div>
              </div>
              <div className="pt-1 pb-8">
                <p>
                  ¡Espejo sin mancha, santo de los santos, sin igual imagen del
                  Dios soberano! ¡Borra nuestras culpas, salva al desterrado y
                  en forma de niño, da al mísero amparo!
                </p>
                <small className="text-yellow-main font-semibold pb-4">
                  Coro: ¡Ven a nuestras almas, ven no tardes tanto!
                </small>
              </div>
            </div>
            <div className="flex">
              <div className="mr-4 flex flex-col items-center">
                <div className="bg-blue-main">
                  <div className="bg-yellow-main flex h-10 w-10 items-center justify-center rounded-full">
                    <p className="text-blue-main">7</p>
                  </div>
                </div>
                <div className="h-full w-px bg-gray-300 dark:bg-slate-500"></div>
              </div>
              <div className="pt-1 pb-8">
                <p>
                  ¡Rey de las naciones, Emmanuel preclaro, de Israel anhelo
                  Pastor del rebaño! ¡Niño que apacientas con suave cayado ya la
                  oveja arisca, ya el cordero manso!
                </p>
              </div>
            </div>
            <div className="flex">
              <div className="mr-4 flex flex-col items-center">
                <div className="bg-blue-main">
                  <div className="bg-yellow-main flex h-10 w-10 items-center justify-center rounded-full">
                    <p className="text-blue-main">8</p>
                  </div>
                </div>
                <div className="h-full w-px bg-gray-300 dark:bg-slate-500"></div>
              </div>
              <div className="pt-1 pb-8">
                <p>
                  ¡Ábranse los cielos y llueva de lo alto bienhechor rocío como
                  riego santo! ¡Ven hermoso Niño, ven Dios humanado! ¡Luce, Dios
                  estrella! ¡Brota, flor del campo!
                </p>
                <small className="text-yellow-main font-semibold pb-4">
                  Coro: ¡Ven a nuestras almas, ven no tardes tanto!
                </small>
              </div>
            </div>
            <div className="flex">
              <div className="mr-4 flex flex-col items-center">
                <div className="bg-blue-main">
                  <div className="bg-yellow-main flex h-10 w-10 items-center justify-center rounded-full">
                    <p className="text-blue-main">9</p>
                  </div>
                </div>
                <div className="h-full w-px bg-gray-300 dark:bg-slate-500"></div>
              </div>
              <div className="pt-1 pb-8">
                <p>
                  ¡Ven, que ya María previene sus brazos, do su niño vean, en
                  tiempo cercanos! ¡Ven, que ya José, con anhelo sacro, se
                  dispone a hacerse de tu amor sagrario!
                </p>
                <small className="text-yellow-main font-semibold pb-4">
                  Coro: ¡Ven a nuestras almas, ven no tardes tanto!
                </small>
              </div>
            </div>
            <div className="flex">
              <div className="mr-4 flex flex-col items-center">
                <div className="bg-blue-main">
                  <div className="bg-yellow-main flex h-10 w-10 items-center justify-center rounded-full">
                    <p className="text-blue-main">10</p>
                  </div>
                </div>
                <div className="h-full w-px bg-gray-300 dark:bg-slate-500"></div>
              </div>
              <div className="pt-1 pb-8">
                <p>
                  ¡Del débil auxilio, del doliente amparo, consuelo del triste,
                  luz del desterrado! ¡Vida de mi vida, mi dueño adorado, mi
                  constante amigo, mi divino hermano!
                </p>
                <small className="text-yellow-main font-semibold pb-4">
                  Coro: ¡Ven a nuestras almas, ven no tardes tanto!
                </small>
              </div>
            </div>
            <div className="flex">
              <div className="mr-4 flex flex-col items-center">
                <div className="bg-blue-main">
                  <div className="bg-yellow-main flex h-10 w-10 items-center justify-center rounded-full">
                    <p className="text-blue-main">11</p>
                  </div>
                </div>
                <div className="h-full w-px bg-gray-300 dark:bg-slate-500"></div>
              </div>
              <div className="pt-1 pb-8">
                <p>
                  ¡Ven ante mis ojos, de ti enamorados! ¡Bese ya tus plantas!
                  ¡Bese ya tus manos! ¡Prosternado en tierra, te tiendo los
                  brazos, y aún más que mis frases, te dice mi llanto!
                </p>
                <small className="text-yellow-main font-semibold pb-4">
                  Coro: ¡Ven a nuestras almas, ven no tardes tanto!
                </small>
              </div>
            </div>
            <div className="flex">
              <div className="mr-4 flex flex-col items-center">
                <div>
                  <div className="flex h-10 w-10 items-center justify-center rounded-full border-2 border-blue-medium-main bg-blue-medium-main">
                    <img
                      className="w-16 h- rounded-full"
                      src="/img/iconos/Gozos_Icon.svg"
                      alt="Ángel"
                      title="Ángel"
                    />
                  </div>
                </div>
              </div>
              <div className="pt-1 ">
                <p className="mb-2 text-xl font-bold text-white dark:text-slate-300">
                  ¡Ven Salvador nuestro por quien suspiramos!
                </p>
              </div>
            </div>
            <Link to="/">
              <h3 className="text-xl text-yellow-main font-bold mt-14">
                <img
                  className="w-8 h-8 rounded-full inline"
                  src="/img/iconos/Flecha_Icon.svg"
                  alt="Flecha para volver"
                  title="Flecha para volver"
                />
                Volver
              </h3>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Gozos;
